module.exports = __webpack_public_path__ + "static/media/5_r_telo_51.04_89.72.1f1921a7.png";